<a routerLink="/shop/wishlist" class="wishlist-link" title="Wishlist">
    <i class="icon-heart-o"></i>
    <span class="wishlist-count badge">{{ wishlistService.wishlistQty | async }}</span>
    <span class="wishlist-txt">Wishlist</span>
</a>